module.exports = __webpack_public_path__ + "media/images/landing__howToPlay__bulletPoint-d34efdaaccb498453565d882a4e330a0.png";